import { FINDINGS_LIMIT_EXCEEDED_FEEDBACK_MODAL } from 'constants/feedbackModal';
import {
  EnumNotificationType,
  TNotificationFieldsFragment,
} from 'generated/graphql';
import { useFeedbackModal } from 'providers';
import NotificationLinkItem from './NotificationLinkItem';
import ResubmitExamContent from './ResubmitExamContent/ResubmitExamContent';
import UploadExamContent from './UploadExamContent/UploadExamContent';

interface INotificationCardContent {
  data: TNotificationFieldsFragment;
  handleUpdate: () => void;
  removeNotification: () => void;
}

const NotificationCardContent = ({
  data,
  handleUpdate,
  removeNotification,
}: INotificationCardContent) => {
  const { openFeedbackModal } = useFeedbackModal();

  const { type } = data;
  if (type === EnumNotificationType.ExamUploadError) {
    return (
      <UploadExamContent
        data={data}
        onOpen={handleUpdate}
        onCompleted={removeNotification}
      />
    );
  } else if (type === EnumNotificationType.ExamAnalysisError) {
    return (
      <ResubmitExamContent
        data={data}
        onOpen={handleUpdate}
        onCompleted={removeNotification}
      />
    );
  }

  const handleClick = () => {
    if (type === EnumNotificationType.ExamReportReady) {
      removeNotification();
      return;
    }

    if (type === EnumNotificationType.FindingsLimitExceeded) {
      openFeedbackModal(FINDINGS_LIMIT_EXCEEDED_FEEDBACK_MODAL);
    }

    handleUpdate();
  };

  return <NotificationLinkItem data={data} onClick={handleClick} />;
};

export default NotificationCardContent;
